import { ErrorResponseDto, ErrorResponseDtoFromJSON } from "@desio/api";
import { accessTokenClienteSelector } from "pages/cliente/_redux/selectors";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { ExtraArgument, RootState } from "store";
import { accessTokenAdminSelector } from "../pages/admin/_redux/selectors";
import { setGeneralError } from "./actions";

export const BASE_URL = 'https://testcertclidev.azurewebsites.net';

const getConfiguration = (Configuration: any, extra: ExtraArgument, getState: () => RootState, isCliente?: boolean) => {
  const c = new Configuration();
  const accessTokenSelector = isCliente ? accessTokenClienteSelector : accessTokenAdminSelector;
  // console.log('location', window.location);
  const configuration: any = {
    basePath: window.location.hostname === 'localhost' ? BASE_URL : '',
    middleware: c.middleware,
    fetchApi: c.fetchApi,
    queryParamsStringify: c.queryParamsStringify,
    headers: {},
    accessToken: accessTokenSelector(getState())
  };

  return configuration;
};

function Utf8ArrayToStr(array: Uint8Array) {
  var out, i, len, c;
  var char2, char3;

  out = '';
  len = array.length;
  i = 0;
  while (i < len) {
    c = array[i++];
    switch (c >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        // 0xxxxxxx
        out += String.fromCharCode(c);
        break;
      case 12:
      case 13:
        // 110x xxxx   10xx xxxx
        char2 = array[i++];
        out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
        break;
      case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
        char2 = array[i++];
        char3 = array[i++];
        out += String.fromCharCode(
          ((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0)
        );
        break;
    }
  }
  return out;
}

function JSONTryParse(str: string): Object {
  try {
    return JSON.parse(str);
  } catch (e) {
    return {
      error: `JSONTryParse ${e}`,
      error_code: str,
      error_description: str
    };
  }
}

function isErrorResponseDto(error: Object): boolean {
  return (error.hasOwnProperty('message') && error.hasOwnProperty('statusCode'));
}

export const decodeError = async (error: Response): Promise<ErrorResponseDto> => {
  let message = error.statusText;
  let statusCode = error.status;
  let errorType = undefined;
  if (error.body) {
    const errorTextReadable = await error.body?.getReader().read();
    if (errorTextReadable.value) {
      const errorTextStr = Utf8ArrayToStr(errorTextReadable.value);
      const errorObject = errorTextStr ? JSONTryParse(errorTextStr) : {};
      if (isErrorResponseDto(errorObject)) {
        const errorResponse = ErrorResponseDtoFromJSON(errorObject);
        errorResponse.message && (message = errorResponse.message);
        errorResponse.statusCode && (statusCode = errorResponse.statusCode);
        errorType = errorResponse.errorType;
      }
    }
  }
  if (message) {
    return {
      message: message,
      statusCode: statusCode,
      errorType: errorType
    }
  } else {
    return {
      message: 'Si è verificato un errore generico',
      statusCode: 999,
      errorType: errorType
    }
  }
}

export const errorHandler = async (error: any, dispatch: ThunkDispatch<RootState, ExtraArgument, AnyAction>, decoded?: boolean) => {
  // console.log(error, error.constructor.name)
  const errorResponse: ErrorResponseDto = decoded ? error : await decodeError(error);
  dispatch(setGeneralError(errorResponse));
};


export default getConfiguration;
